import type { ChangeEvent } from "react";
import { UserPlus, X } from "lucide-react";
import OutsideClickHandler from "react-outside-click-handler";
import {
  ListAddWrapper,
  OwnerList,
} from "../../pages/CreateProperty/components/DescriptionForm/twStyles";
import { FLOW_ORANGE_ACTION_BUTTON_BASE } from "../../styles/twDesignPrimitives";

type OwnerOption = { id: number; email: string };

type Props = {
  hasSelectedOwner: boolean;
  inputValue: string;
  isFetching: boolean;
  isDropdownOpen: boolean;
  owners: OwnerOption[];
  onInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onSelectOwner: (id: number) => void;
  onClearOwner: () => void;
  onCloseDropdown: () => void;
  onCreateOwner: () => void;
};

export default function OwnerEmailSearchField({
  hasSelectedOwner,
  inputValue,
  isFetching,
  isDropdownOpen,
  owners,
  onInputChange,
  onSelectOwner,
  onClearOwner,
  onCloseDropdown,
  onCreateOwner,
}: Props) {
  return (
    <div className="flex items-stretch gap-2">
      <OwnerList className="min-w-0 flex-1">
        <OutsideClickHandler onOutsideClick={onCloseDropdown}>
          <div className="relative w-full min-w-0">
            <ListAddWrapper className="h-9">
              <input
                readOnly={hasSelectedOwner}
                value={inputValue}
                placeholder="Buscar por e-mail"
                onChange={hasSelectedOwner ? undefined : onInputChange}
              />
              {hasSelectedOwner ? (
                <button
                  type="button"
                  title="Limpar proprietário"
                  aria-label="Limpar proprietário"
                  onClick={onClearOwner}
                  className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded text-slate-500 hover:bg-slate-100"
                >
                  <X className="!h-3.5 !w-3.5 !text-slate-500" aria-hidden />
                </button>
              ) : null}
            </ListAddWrapper>
            {!hasSelectedOwner && isFetching ? (
              <div id="users">Carregando...</div>
            ) : !hasSelectedOwner && isDropdownOpen && owners.length >= 1 ? (
              <div id="users">
                {owners.map((owner) => (
                  <button
                    key={owner.id}
                    type="button"
                    onMouseDown={(event) => {
                      event.preventDefault();
                      onSelectOwner(owner.id);
                    }}
                  >
                    {owner.email}
                  </button>
                ))}
              </div>
            ) : null}
          </div>
        </OutsideClickHandler>
      </OwnerList>

      <button
        type="button"
        onClick={onCreateOwner}
        className={`${FLOW_ORANGE_ACTION_BUTTON_BASE} h-9 shrink-0 gap-1.5 px-3 text-xs`}
      >
        <UserPlus className="h-4 w-4" aria-hidden />
        Cadastrar
      </button>
    </div>
  );
}
